import React from 'react';

import { IndividualReviewContainer } from '../../../../../containers';

export const IndividualLetsReview = () => <IndividualReviewContainer />;
